import { ServicePluginDefinition } from '@wix/sdk-types';
import {
  Context,
  CalculateTaxRequest,
  CalculateTaxResponse,
} from './service-plugins-types.js';
import { transformRESTAddressToSDKAddress } from '@wix/sdk-runtime/transformations/address';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import {
  renameKeysFromSDKRequestToRESTRequest,
  renameKeysFromRESTResponseToSDKResponse,
} from '@wix/sdk-runtime/rename-all-nested-keys';

export interface CalculateTaxEnvelope {
  request: CalculateTaxRequest;
  metadata: Context;
}

export const provideHandlers = ServicePluginDefinition<{
  /**
   *
   * Calculates tax for the provided line items.
   *
   * Tax is calculated for each line item based on the tax region
   * in `lineItems.taxRegionId` and the tax group in `lineItems.taxGroupId`.
   *
   * The breakdown of calculated tax returned, includes:
   * + `taxSummary`: The overall total tax calculated.
   * + `lineItemTaxDetails.taxBreakdown`: The tax calculated for each line item in each jurisdiction.
   * + `lineItemTaxDetails.taxSummary`: The total tax calculated for each line item. */
  calculateTax(
    payload: CalculateTaxEnvelope
  ): CalculateTaxResponse | Promise<CalculateTaxResponse>;
}>('TAX_CALCULATION_PROVIDER', [
  {
    name: 'calculateTax',
    primaryHttpMappingPath: '/v1/calculate-tax',
    transformations: {
      toREST: (payload: any) => {
        const toRestResponse = payload;

        return renameKeysFromSDKRequestToRESTRequest(toRestResponse);
      },
      fromREST: (payload: any) => {
        const fromRestRequest = transformPaths(payload, [
          {
            transformFn: transformRESTAddressToSDKAddress,
            paths: [{ path: 'request.addresses', isRepeated: true }],
          },
        ]);

        return renameKeysFromRESTResponseToSDKResponse(fromRestRequest);
      },
    },
  },
]);
